/**************************************************
 * Nombre:       Formulario_Profesor
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {SchoolOutlined} from '@mui/icons-material'
import IngresoImagenCrop from "../../../Modulo_formularios/Componentes/IngresoImagenCrop";

const Formulario_Profesor = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoImagenCrop dato={'img'} {...props} alto={1} ancho={1}/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={SchoolOutlined} nombre={'Nombre del profesor'} dato={'nombre'} {...props}
                                  ejemplo={'Esp Andrés Felipe Ordóñez Pantoja'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={2} nombre={'Titulo profesional'} dato={'titulo'} {...props}
                                  ejemplo={'Abogado especialista en Derecho Penal y Administrativo'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={14} nombre={'Perfil profesional'} dato={'perfil'} {...props}
                                  ejemplo={'Abogado especialista en Derecho Penal y Administrativo, candidato a Magíster en Derecho Penal y Conciliador en Derecho. Cuento con una sólida trayectoria en la Rama Judicial (actual Oficial Mayor en propiedad) y amplia experiencia en el sector público, habiendo destacado como Personero Auxiliar, Defensor Público y Asesor Jurídico en entidades como la Fiscalía y CORPONARIÑO. Experto en la gestión de mecanismos alternativos de solución de conflictos tras liderar el Centro de Conciliación de la Universidad de Nariño.'}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Profesor